import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';
import { Collapse } from 'reactstrap';

import ContextMenu from 'app/ContextMenu/components/ContextMenu';
import { noop } from 'lib/noop';
import { SectionHeader } from 'ui/Components';
import { renderArrowStyle } from 'ui/helpers';

import styles from './ActionableComponentsList.css';

/**
 * This component is a react component.
 * This component shows the given list of components with given actions as context menu
 * @returns {Component} Canvas Menu component
 */
export default class ActionableComponentsList extends Component {
  static propTypes = {
    components: propTypes.arrayOf(propTypes.shape()),
    context: propTypes.string,
    getItemActions: propTypes.func,
    headerText: propTypes.string,
    isRecentComponentSection: propTypes.bool,
    itemActions: propTypes.arrayOf(
      propTypes.shape({
        text: propTypes.string.isRequired,
        action: propTypes.string.isRequired
      })
    ),
    onActionSelect: propTypes.func,
    onItemClick: propTypes.func.isRequired
  };

  static defaultProps = {
    components: [],
    context: 'component',
    getItemActions: noop,
    headerText: '',
    isRecentComponentSection: true,
    itemActions: undefined,
    onActionSelect: noop
  };

  constructor(props) {
    super(props);

    this.state = { isOpen: true };

    this.headerClick = this.headerClick.bind(this);
  }

  headerClick() {
    this.setState(ps => ({ isOpen: !ps.isOpen }));
  }

  render() {
    const {
      components,
      context,
      getItemActions,
      headerText,
      isRecentComponentSection,
      onActionSelect,
      onItemClick,
      itemActions
    } = this.props;

    const { isOpen } = this.state;

    return (
      <Fragment>
        <div className="border border-secondary">
          <SectionHeader onClick={this.headerClick}>
            {headerText}
            {renderArrowStyle(isOpen)}
          </SectionHeader>
        </div>
        <Collapse isOpen={isOpen}>
          <div className={`${styles.list} border border-secondary`}>
            {components.map(component => {
              const actions =
                itemActions || getItemActions(component, context, isRecentComponentSection);
              return (
                <div
                  className={`d-flex justify-content-between p-2 ${styles.listItem}`}
                  key={component.Id}
                >
                  <button
                    className={classnames(
                      'bg-transparent',
                      'border-0',
                      'text-left',
                      'text-truncate',
                      'w-100',
                      component.disabled && 'text-muted'
                    )}
                    data-test-id="actionable-component-Item"
                    disabled={component.disabled}
                    onClick={() => onItemClick(component)}
                    title={component.ComponentName}
                    type="button"
                  >
                    {component.ComponentName}
                  </button>
                  {Array.isArray(actions) && (
                    <ContextMenu
                      actions={actions}
                      onActionSelect={action => onActionSelect(component, action, context)}
                      popoverPlacement="left"
                      rem={1.5}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </Collapse>
      </Fragment>
    );
  }
}
